import { LoadDataService } from './services/loadData.service';
import { Ferme } from './models/ferme.model';
import { CurrentUserService } from './services/currentUserService';
import { FermeService } from './services/ferme.service';
import { RoleProvider } from './role.provider';
import { NbSecurityModule, NbRoleProvider } from '@nebular/security';
import { environment } from '../environments/environment';
/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { APP_BASE_HREF } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, Injectable, Injector, Inject, APP_INITIALIZER } from '@angular/core';
import {
  HttpClientModule,
  HttpClient,
  HTTP_INTERCEPTORS,
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ThemeModule } from './@theme/theme.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import {
  NbPasswordAuthStrategy,
  NbAuthModule,
  NbAuthJWTToken,
  NB_AUTH_TOKEN_INTERCEPTOR_FILTER,
  NbAuthService,
  NbAuthToken  } from '@nebular/auth';
import { AuthGuard } from './auth/auth-guard.service';
import { NbDialogModule, NbToastrModule } from '@nebular/theme';
import { of as observableOf } from 'rxjs/observable/of';
import {TranslateModule, TranslateLoader} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import { Observable, config } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { UserIdleModule } from 'angular-user-idle';
import { ButtonRenderComponent } from './@theme/components/tabs/tabUtilisateur/test.component';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}


@Injectable()
export class NbAuthJWTInterceptor implements HttpInterceptor {
  baseUrl: string = environment.apiUrl;
  constructor(private injector: Injector,
              @Inject (NB_AUTH_TOKEN_INTERCEPTOR_FILTER) protected filter) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if(req.url == this.baseUrl + '/auth/refreshToken'){
      return next.handle(req);
    }
    // do not intercept request whose urls are filtered by the injected filter
      if (this.filter(req)) {
        return this.authService.isAuthenticatedOrRefresh()
          .pipe(
            switchMap(authenticated => {
              if (authenticated) {
                  return this.authService.getToken().pipe(
                    switchMap((token: NbAuthToken) => {
                      const JWT = `Bearer ${token.getValue()}`;
                      req = req.clone({
                        setHeaders: {
                          Authorization: JWT,
                        },
                      });
                      return next.handle(req);
                    }),
                  )
              } else {
                 // Request is sent to server without authentication so that the client code
                 // receives the 401/403 error and can act as desired ('session expired', redirect to login, aso)
                return next.handle(req);
              }
            }),
          )
      } else {
      return next.handle(req);
    }
  }

  protected get authService(): NbAuthService {
    return this.injector.get(NbAuthService);
  }

}


const formSetting: any = {
  redirectDelay: 0,
  showMessages: {
    success: true,
  },
};
@NgModule({
  declarations: [AppComponent],
  // entryComponents: [ButtonRenderComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    NbToastrModule.forRoot({duration: 500}),
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
      },
    }),
    NgbModule.forRoot(),
    ThemeModule.forRoot(),
    NbDialogModule.forRoot(),
    CoreModule.forRoot(),
    UserIdleModule.forRoot({idle: 600, timeout: 60, ping: 5}),
    NbAuthModule.forRoot({
      strategies: [
        NbPasswordAuthStrategy.setup({
          name: 'email',
          token: {
            class: NbAuthJWTToken,
            key: 'access_token',
          },
          baseEndpoint: environment.apiUrl + '/auth',
            login: {
              endpoint: '/login',
              method: 'post',
            },
            refreshToken: {
              endpoint: '/refreshToken',
              method: 'post',
            },
            register: {
              endpoint: '/api/Users/{id}',
            },
        }),
      ],
      forms: {
        login: formSetting,
        register: formSetting,
        requestPassword: formSetting,
        resetPassword: formSetting,
        logout: {
          redirectDelay: 0,
        },
      },
    }),
    NbSecurityModule.forRoot({
      accessControl: { // Chef Opérateur
        2: {
          view: ['view', 'menuChefOperateur'],
        },
        3: { // Opérateur
          view: ['view', 'menuOperateur'],
        },
        1: { // Admin
          parent: 'guest',
          modify : ['recette'],
        },
      },
    }),
  ],
  bootstrap: [AppComponent],
  providers: [
    { provide: APP_BASE_HREF, useValue: '/' },
    { provide: APP_INITIALIZER, useFactory: userProviderFactory, deps: [LoadDataService], multi: true },
    { provide: APP_INITIALIZER, useFactory: fermesProviderFactory, deps: [LoadDataService], multi: true },
    { provide: NbRoleProvider, useClass: RoleProvider },
    { provide: HTTP_INTERCEPTORS, useClass: NbAuthJWTInterceptor, multi: true},
    AuthGuard,
    FermeService,
    CurrentUserService,
  ],
})
export class AppModule {
}

export function fermesProviderFactory(provider: LoadDataService) {
  return () => provider.loadFermes();
}

export function userProviderFactory(provider: LoadDataService) {
  return () => provider.loadUser();
}
